import { ROUTES } from '@/config/routes';
import { LegacyPrefixRedirect } from '@/routes/LegacyPrefixRedirect';
import { useLayoutVersionStore } from '@/stores/useLayoutVersionStore';

import { ClassicServicesRoutes } from './classic';

const servicesLink = ROUTES.getLink(`services`);
const irmServicesLink = ROUTES.getLink(`irm.services`);

// /demais-servicos: the classic layout keeps the old page here, with its own menu; the new layout
// puts Demais Serviços inside the IRM, so it sends there. `IrmServicesEntry` is the other side.
export const ServicesEntry = () => {
  const version = useLayoutVersionStore((state) => state.version);

  return version === `new` ? (
    <LegacyPrefixRedirect from={servicesLink} to={irmServicesLink} />
  ) : (
    <ClassicServicesRoutes />
  );
};
